import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import type { ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { ForwardCallStore } from '../../store/ForwardCallStore'
import styles from './styles.module.scss'

export const ForwardCallNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof ForwardCallStore)) return null

  const { configuredNumbers } = store

  return (
    <SmartCallActionNode
      iconProps={ForwardCallStore.iconProps}
      title={ForwardCallStore.title}
      placeholder={'Select a number'}
      content={
        configuredNumbers.length
          ? configuredNumbers.map((number) => (
              <div className={styles.chip} key={number.phone.id}>
                <Typography ariaLabel={'left'} variant={'text-input-field-r'} ellipsis>
                  {number.phone.formatted_number} → to
                </Typography>
                <Typography
                  ariaLabel={'left'}
                  variant={'text-input-field-r'}
                  ellipsis
                  className={styles.forward}
                >
                  {number.forwardToLabel}
                </Typography>
              </div>
            ))
          : null
      }
      {...props}
    />
  )
})
